import React from 'react';
import styles from './PermissionsLogHistory.module.scss';
import Util from '../../../Util';
import ProgressSpinner from '../../../Components/ProgressSpinner';
import Http from '../../../Api/http';
import ButtonsBarLookupList from '../../../Components/ButtonsBarLookupList';
import Messages from '../../../Components/Messages';
import Dropdown from '../../../Components/Dropdown';
import Calendar from '../../../Components/Calendar';
import UsersSearch from '../Users/UsersSearch';
//import AccessSearch from '../PermissionsAccessList/AccessSearch';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Card from '../../../Components/Card';
import DataGrid from '../../../Components/DataGridView/DataGridView';
import Print from '../../../Print';
import MultiSelect from '../../../Components/MultiSelect';
import { async } from 'regenerator-runtime';

const $ = window.$;
export default class PermissionsLogHistory extends React.Component {
  constructor(props) {
    super(props);
    this.doHotKeys = true;
    this.transTypeList = this.getTransType();
    this.state = {
      activeIndex: 0,
      loading: true,
      pageInfo: this.setPageInfo(),
      data: [],
      selectedRows: {},
      transTypeList: this.transTypeList,
      stateFromDate: new Date(),
      stateToDate: new Date(),
      mainRolesList: this.mainRolesList,
      system: undefined,
      StatusFilter: $.strings.PermissionsLogHistory.transSuccess,
      globalFilter: '',
      stateDate: new Date(2000, 1, 1),
      isDesktop: window.innerWidth > 800,
      processUserList:[],
      userTransList:[],
      accessList:[]
    };
  }

  componentDidMount = async () => {
    if (!Util.checkIsSuperAdmin() ) {
      Util.goTo('/Access');
    }

    let processUserPromise = this.getProcessUserList();
    let dataProcessUser = await processUserPromise;

    let accessPromise = this.getAccessList();
    let dataAccess = await accessPromise;

    let jobRolePromise = this.getJobRoleList();
    let dataJobRole = await jobRolePromise;
    this.setState(
      {
        loading: false,
        processUserList: dataProcessUser,
        processUser: dataProcessUser ? dataProcessUser : undefined,
        userTransList: dataProcessUser,
        userTrans: dataProcessUser ? dataProcessUser : undefined,
        accessList: dataAccess,
        access: dataAccess ? dataAccess : undefined,
        jobRoleList: dataJobRole,
        jobRole: dataJobRole && dataJobRole.length > 0 ? dataJobRole[0] : undefined,
        transType: this.transTypeList,
      },
      async() => {
        let dataPromise = await this.getData(true);
        this.setState({data: dataPromise},()=>
        {
          this.printFilters = this.state;
        });
      }
    );

    document.addEventListener('keydown', this.onPageKeyDown);
    document.addEventListener('resize', this.updatePredicate);
  };

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.onPageKeyDown);
    document.removeEventListener('resize', this.updatePredicate);
  };

  onPageKeyDown = async (e) => {
    if (e.ctrlKey && e.keyCode === Util.keyboardKeys.F5) return;
    if (!this.doHotKeys) return;
    this.doHotKeys = false;
    switch (e.keyCode) {
      case Util.keyboardKeys.F5: {
        e.preventDefault();
        await this.getData(false);
        break;
      }
      default: {
      }
    }
    this.doHotKeys = true;
  };

  updatePredicate = () => {
    this.setState({ isDesktop: window.innerWidth > 800 });
  };

  onAddClose = (doRefreh) => {
    if (doRefreh) this.getData(false);
    this.setState({ dlgAddVisible: false });
  };

  onAddSuccess = (result) => {
    if (result) {
      this.setState({ dlgAddVisible: false });
      this.getData(false);
    }
  };
  handleUserInput = (e) => {
    const name = e.target.id;
    const value = e.target.value;
    this.setState({ [name]: value });
  };
  render() {
    const gridStyle = { minHeight: this.state.activeIndex === null || this.state.activeIndex === undefined ? '55vh' : '40vh' };
    let dlgWidth = this.state.isDesktop ? '40%' : '80%';

    return (
      <div ref={(e) => (this.divMain = e)} className={styles.PermissionsLogHistory} style={{ minHeight: '80vh' }}>
        <ProgressSpinner loading={this.state.loading} />
        <div className="p-grid">
          <h2 className={styles.title}>{this.state.pageInfo.title}</h2>
        </div>
        <Card>
          <ButtonsBarLookupList
            onRefresh={() => this.getData(false)}
            onPrint={this.onPrint}
            onExcelExport={this.onExcelExport}
            onErase={this.onErase}
            pageId={this.state.pageInfo.pageId}
          />
          <Messages innerRef={(e) => (this.messages = e)} />
        </Card>
        {this.state.usersSearchVisible && (
          <UsersSearch ref={(ref) => (this.dlgUsersSearch = ref)} onSearchSuccess={this.onSearchOk} onClose={this.onUsersSearchClose} />
        )}
        {this.state.userTransSearchVisible && (
          <UsersSearch
            ref={(ref) => (this.dlgUserTransSearch = ref)}
            onSearchSuccess={this.onUserTransSearchOk}
            onClose={this.onUserTransSearchClose}
          />
        )}
        {/* <AccessSearch ref={(ref) => (this.dlgAccessSearch = ref)} onSearchSuccess={this.onAccessSearchOk} /> */}
        <Accordion activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
          <AccordionTab header={$.strings.filterCaption}>
            <div id="divFilters">
              <div className="p-grid">
                {/* من تاريخ */}
                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  <Calendar
                    id="stateFromDate"
                    inputId="stateFromDate"
                    value={this.state.stateFromDate && this.state.stateFromDate.getFullYear() > 2000 ? this.state.stateFromDate : ''}
                    caption={$.strings.PermissionsLogHistory.stateFromDate}
                    onChange={this.handleUserInput}
                    readOnlyInput={true}
                  />
                </div>
                {/* الى تاريخ */}
                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  <Calendar
                    id="stateToDate"
                    inputId="stateToDate"
                    value={this.state.stateToDate && this.state.stateToDate.getFullYear() > 2000 ? this.state.stateToDate : ''}
                    caption={$.strings.PermissionsLogHistory.stateToDate}
                    onChange={this.handleUserInput}
                    readOnlyInput={true}
                  />
                </div>
                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  {/* مستخدم العملية*/}
                    <MultiSelect
                         id="processUser"
                          value={this.state.processUser}
                           options={this.state.processUserList}
                            caption={$.strings.PermissionsLogHistory.processUser}
                            onChange={this.handleMultiSelect}
                            optionLabel="Name"
                            display="chip"
                            maxSelectedLabels="2"
                            filter
                             />

                </div>
                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  {/*مستخدم الحركة*/}

<MultiSelect
                         id="userTrans"
                          value={this.state.userTrans}
                           options={this.state.userTransList}
                            caption={$.strings.PermissionsLogHistory.userTrans}
                            onChange={this.handleMultiSelect}
                            optionLabel="Name"
                            display="chip"
                            maxSelectedLabels="2"
                            filter
                             />
                </div>
                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  {/*الدور الوظيفي*/}
                  <Dropdown
                    id="jobRole"
                    value={this.state.jobRole}
                    options={this.state.jobRoleList}
                    onChange={this.handleUserInput}
                    caption={$.strings.PermissionsLogHistory.jobRole}
                    optionLabel="name"
                    optionLabelLang2="name_lang2"
                    filter
                  />
                </div>

                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  {/*الصلاحية*/}
                  <MultiSelect
                         id="access"
                          value={this.state.access}
                           options={this.state.accessList}
                            caption={$.strings.PermissionsLogHistory.access}
                            onChange={this.handleMultiSelect}
                            optionLabel="access_name"
                            display="chip"
                            maxSelectedLabels="2"
                            filter
                             />
                </div>
                <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                  {/*نوع الحركة*/}
                  <MultiSelect
                         id="transType"
                          value={this.state.transType}
                           options={this.state.transTypeList}
                            caption={$.strings.PermissionsLogHistory.transType}
                            onChange={this.handleMultiSelect}
                            optionLabel="name"
                            display="chip"
                            maxSelectedLabels="2"
                            filter
                             />

                </div>
              </div>
            </div>
          </AccordionTab>
        </Accordion>

        <div className="p-grid">
          <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
            <Card>
              <DataGrid
                style={gridStyle}
                ref={(e) => (this.grid = e)}
                exportFileName={this.state.pageInfo.title}
                isReport={true}
                theme="default-light"
                idProperty="ser"
                scheme={this.getScheme()}
                dataSource={this.state.data}
                onRowDoubleClick={this.onRowDoubleClick}
                pageId={this.state.pageInfo.pageId}
              />
            </Card>
          </div>
        </div>
      </div>
    );
  }
  handleMultiSelect = (e) => {
    const name = e.target.id;
    const value = e.target.value;
    this.setState({ [name]: value });
}
  searchProcessUser = (e) => {
    //this.dlgUsersSearch.show();
    this.setState({ usersSearchVisible: true });
  };
  searchAccess = (e) => {
    this.dlgAccessSearch.show();
  };

  onSearchOk = (obj) => {
    let selectedUser = this.state.processUserList.filter((element) => element.id === obj.id);
    if (selectedUser && selectedUser.length > 0) {
      selectedUser = selectedUser[0];
    }
    this.setState({ processUser: selectedUser, usersSearchVisible: false });
  };
  onUserTransSearchOk = (obj) => {
    let selectedUser = this.state.userTransList.filter((element) => element.id === obj.id);
    if (selectedUser && selectedUser.length > 0) {
      selectedUser = selectedUser[0];
    }
    this.setState({ userTrans: selectedUser, userTransSearchVisible: false });
  };
  onUserTransSearchClose = () => {
    this.setState({ userTransSearchVisible: false });
  };
  onUsersSearchClose = () => {
    this.setState({ usersSearchVisible: false });
  };
  onAccessSearchOk = (obj) => {
    let selectedAccess = this.state.accessList.filter((element) => element.id === obj.id);
    if (selectedAccess && selectedAccess.length > 0) {
      selectedAccess = selectedAccess[0];
    }
    this.setState({ access: selectedAccess });
  };
  searchUserTrans = (obj) => {
    //this.dlgUserTransSearch.show();
    this.setState({ userTransSearchVisible: true });
  };
  handleMainRole = (e) => {
    const value = e.target.value;
    this.setState({ mainRoles: value }, () => this.getSubRole(value));
  };
  validateField() {
    let fromDate = this.state.stateFromDate;
    let toDate = this.state.stateToDate;
    if (fromDate > toDate) {
      Util.showErrorMsg(this.messages, $.strings.PermissionsLogHistory.ValidateDate);
      return false;
    }
    return true;
  }
  getProcessUserList = async () => {
    let dataTemp = [];
    const params = {
      userId :-1,
      status: 0
    };
    let res = await Http.getJsonAxios(Http.actions.Users.urlGetUsers, params, this.state.pageInfo.pageId);

    if (res.status === 200) {
      dataTemp = res.data.list;
      // if (dataTemp) {
      //   dataTemp.splice(0, 0, {
      //     ID: -1,
      //     Name: $.strings.all,
      //   });
    //}
  }
return dataTemp;

  };
  getAccessList = async () => {
    let dataTemp=[];
    const params = {};
    let res = await Http.getJsonAxios(Http.actions.Users.urlGetUserAccessCombo, params, this.state.pageInfo.pageId);
    if (res.status === 200) {
      dataTemp = res.data.list;
      // if (dataTemp) {
      //   dataTemp.splice(0, 0, {
      //     access_id: -1,
      //     access_name: $.strings.all
      //   });
      // }
    }
    return dataTemp;
  };
  getJobRoleList = async () => {

    let dataTemp;
    const params = {
      id :-1
    };
    let res = await Http.getJsonAxios(Http.actions.Roles.urlGetRoles, params, this.state.pageInfo.pageId);
    if (res.status === 200) {
      dataTemp = res.data.list;
      if (dataTemp) {
        dataTemp.splice(0, 0, {
          id: -1,
          name: $.strings.all,
          name_lang2: $.strings.all,
        });
      }
    }
    return dataTemp;
  };

  btnNewClick = () => {
    // Util.goTo("/AccessRights/AccessAdd/")
  };
  onEdit = async () => {
    // if (this.tblData.state.selection) {
    //   Util.goTo("AccessAdd/" + this.tblData.state.selection.id)
    // }
    // else
    //  Util.showInfoMsg(this.messages, $.strings.selectRow)
  };
  getDataForSelection = async (id) => {
    let dataTemp;
    this.setState({ loading: true });
    const params = {
      status: Util.getStatusId(this.state.StatusFilter),
      id: id,
    };

    let res = await Http.getJsonAxios(Http.actions.Groups.urlGetGroups, params, this.state.pageInfo.pageId);
    if (res.status === 200) {
      dataTemp = res.data._PermissionsLogHistory;
    }
    return dataTemp;
  };
  getData = async (fromLoad) => {
    let dataTemp = [];
    if (!fromLoad) this.setState({ loading: true });
    if (!this.validateField()) {
      this.setState({ loading: false });
      return;
    }
    let user_list = []
    if (this.state.processUser) {
      for (let index = 0; index < this.state.processUser.length; index++) {
        user_list.push(this.state.processUser[index].ID)
      }
  }
  let user_trans_list = []
  if (this.state.userTrans) {
    for (let index = 0; index < this.state.userTrans.length; index++) {
      user_trans_list.push(this.state.userTrans[index].ID)
    }
}
let access_list = []
if (this.state.access) {
  for (let index = 0; index < this.state.access.length; index++) {
    access_list.push(this.state.access[index].access_id)
  }
}
console.log(this.state.processUser)
    let rowIndex = this.grid.flex.selection.row;
    let colIndex = this.grid.flex.selection.col;
    const params = {
      user_list: user_list,//
      user_trans_list: user_trans_list,//
      log_type: !this.state.transType ? 0 : this.state.transType.id,
      from_date: this.state.stateFromDate,//
      to_date: this.state.stateToDate,//
      role_id: !this.state.jobRole ? 0 : this.state.jobRole.id,//
      access_list: access_list,
    };
    let res = await Http.postMultipartAxios(Http.actions.Users.urlGetHistoryAccess, params, this.state.pageInfo.pageId);
    if (res.status === 200) {
      dataTemp = res.data.list;
    }
console.log(dataTemp)
    dataTemp.forEach(function (e) {
      switch (e.log_type) {
        case 1: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption1;
          break;
        }
        case 2: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption2;
          break;
        }
        case 3: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption3;
          break;
        }
        case 4: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption4;
          break;
        }
        case 5: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption5;
          break;
        }
        case 6: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption6;
          break;
        }
        case 7: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption7;
          break;
        }
        case 8: {
          e.log_type_name = $.strings.PermissionsLogHistory.transTypeOption8;
          break;
        }
        default: {
          e.log_type_name = '';
          break;
        }
      }
    });

    if (fromLoad) return dataTemp;
    else {
      this.setState({ data: dataTemp, loading: false }, () => {
        Util.gridColumnStartEditing(this.grid, rowIndex, colIndex, false);
        this.printFilters = this.state;
      });
    }
  };

  onErase = () => {
    this.setState(
      {
        stateFromDate: new Date(),
        stateToDate: new Date(),
        data: [],
        processUser: this.state.processUserList && this.state.processUserList.length > 0 ? this.state.processUserList[0] : undefined,
        userTrans: this.state.userTransList && this.state.userTransList.length > 0 ? this.state.userTransList[0] : undefined,
        access: this.state.accessList && this.state.accessList.length > 0 ? this.state.accessList[0] : undefined,
        jobRole: this.state.jobRoleList && this.state.jobRoleList.length > 0 ? this.state.jobRoleList[0] : undefined,
        transType : this.state.transTypeList[0]
      },
      async () => await this.getData(false)
    );
  };

  getStatusName = (statusId) => {
    switch (statusId) {
      case 1: {
        return $.strings.PermissionsLogHistory.transSuccess;
      }
      case 0: {
        return $.strings.PermissionsLogHistory.transError;
      }
      default: {
        return '';
      }
    }
  };

  onPrint = async () => {
    if (!this.state.data || this.state.data.length <= 0) {
      Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint);
      return;
    }

    let obj = Print.getReportPrintObject(this.state.pageInfo.title, this.grid, this.state.data);

    if (this.printFilters) {
      if (this.printFilters.stateFromDate) {
        obj.headers.firstHeader.rightText += $.strings.PermissionsLogFile.stateFromDate + ': ' + this.printFilters.stateFromDate.toLocaleDateString();
      }
      if (this.printFilters.stateToDate) {
        obj.headers.secondHeader.rightText += $.strings.PermissionsLogFile.stateToDate + ': ' + this.printFilters.stateToDate.toLocaleDateString();
      }

      if (this.printFilters.processUser) {
        let name = Util.getNameByUserLanguage(this.printFilters.processUser.name, this.printFilters.processUser.name_lang2);
        obj.headers.firstHeader.centerText += $.strings.PermissionsLogHistory.processUser + ': ' + name;
      }
      if (this.printFilters.userTrans) {
        let name = Util.getNameByUserLanguage(this.printFilters.userTrans.name, this.printFilters.userTrans.name_lang2);
        obj.headers.secondHeader.centerText += $.strings.PermissionsLogHistory.userTrans + ': ' + name;
      }
      if (this.printFilters.jobRole) {
        let name = Util.getNameByUserLanguage(this.printFilters.jobRole.name, this.printFilters.jobRole.name_lang2);
        obj.headers.firstHeader.leftText += ' ' + $.strings.PermissionsLogHistory.jobRole + ': ' + name;
      }
      if (this.printFilters.access) {
        let name = Util.getNameByUserLanguage(this.printFilters.access.name, this.printFilters.access.name_lang2);
        obj.headers.secondHeader.leftText += ' ' + $.strings.PermissionsLogHistory.access + ': ' + name;
      }
      if (this.printFilters.access) {
        let name = Util.getNameByUserLanguage(this.printFilters.transType.name, this.printFilters.transType.name_lang2);
        obj.headers.thirdHeader.rightText += ' ' + $.strings.PermissionsLogHistory.transType + ': ' + name;
      }
    }

    Print.doPrintReport(obj);
  };

  doPrint = async () => {
    this.setState({ loading: true });
    let result = false;
    const params = {};

    let res = await Http.getJsonAxios(Http.actions.AccessList.urlGetSavePrintLogLookups, params, this.state.pageInfo.pageId);
    if (res.status === 200) result = true;

    this.setState({ loading: false });
    return result;
  };
  onExcelExport = async () => {
      this.tblData.excelExport();
  };

  doExcelExport = async () => {
    this.setState({ loading: true });
    let result = false;
    const params = {};
    //console.log(this.state.pageInfo.pageId)
    let res = await Http.getJsonAxios(Http.actions.AccessList.urlGetSaveExportToExcelLogLookups, params, this.state.pageInfo.pageId);
    if (res.status === 200) {
      result = true;
    }

    this.setState({ loading: false });
    return result;
  };
  onRowDoubleClick = () => {
    // if (this.tblData.state.selection) {
    //  Util.goToNewTab("AccessAdd/" + this.tblData.state.selection.id)
    //  }
    //  else
    //  Util.showInfoMsg(this.messages, $.strings.selectRow)
  };
  showFilters = (event) => {
    if (event.target.className === 'pi pi-angle-double-down') {
      document.getElementById('divFilters').style.display = '';
      event.target.className = 'pi pi-angle-double-up';
    } else if (event.target.className === 'pi pi-angle-double-up') {
      document.getElementById('divFilters').style.display = 'none';
      event.target.className = 'pi pi-angle-double-down';
    }
  };

  setPageInfo = () => {
    let pageId;
    let title;

    pageId = 0;
    title = $.strings.PermissionsLogHistory.title;

    return { pageId: pageId, title: title };
  };

  statusTemplate = (rowData, column) => {
    let statusColor = rowData.status === 1 ? 'limegreen' : 'red';
    return (
      <>
        <span className="p-column-title">{column.header}</span>
        <span style={{ color: statusColor, fontWeight: 'bold' }}>{this.getStatusName(rowData['status'])}</span>
      </>
    );
  };

  getStatusId = (statusName) => {
    switch (statusName) {
      case $.strings.PermissionsLogHistory.transSuccess: {
        return 1;
      }
      case $.strings.PermissionsLogHistory.transError: {
        return 0;
      }
      default: {
        return -1;
      }
    }
  };

  getScheme = () => {
    return {
      name: 'permissionsLogHistoryScheme_Table',
      filter: true,
      showFooter: true,
      sortable: true,
      allowGrouping: false,
      responsiveColumnIndex: 2,
      columns: [
        { name: 'ser', header: '##', width: 70, dataType: 'Number', aggregate: 'Cnt', columnWidth: '2' },
        { name: 'user_code', header: $.strings.PermissionsLogHistory.user_code, width: 120, columnWidth: '2' },
        {
          name: 'user_name',
          header: $.strings.PermissionsLogHistory.user_name,
          visible: true,
          visibleInColumnChooser: true,
          width: '*',
          minWidth: 150,
          columnWidth: '*',
        },
        { name: 'trans_date', header: $.strings.PermissionsLogHistory.log_date, width: 120, columnWidth: '2' },
        {
          name: 'trans_user_name',
          header: $.strings.PermissionsLogHistory.trans_user_name,
          width: 200,
          visible: true,
          visibleInColumnChooser: true,
          columnWidth: '2',
        },
        {
          name: 'group_name',
          header: $.strings.PermissionsLogHistory.role_name,
          width: 200,
          columnWidth: '2',
          visible: true,
          visibleInColumnChooser: true,
        },
        { name: 'trans_type', header: $.strings.PermissionsLogHistory.log_type, columnWidth: '2' },
        {
          name: 'access_id',
          header: $.strings.PermissionsLogHistory.access_id,
          width: 130,
          columnWidth: '2',
          visible: true,
          visibleInColumnChooser: true,
        },
        {
          name: 'access_name',
          header: $.strings.PermissionsLogHistory.access_name,
          width: 200,
          columnWidth: '2',
          visible: true,
          visibleInColumnChooser: true,
        },
   
      ],
    };
  };
  getPrintHeader = () => {
    var rightFilter = '';
    var leftFilter = '';
    rightFilter = $.strings.status + ': ' + this.state.StatusFilter;

    var generalSettings = localStorage.getItem('generalSettings');
    if (generalSettings) generalSettings = JSON.parse(generalSettings);

    if (!generalSettings || generalSettings.headerType === 'Image') {
      return (
        <React.Fragment>
          {$.getPrintLogo()}
          <h3 className={styles.title} style={{ textAlign: 'center' }}>
            {this.state.pageInfo.title}
          </h3>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 15,
            }}
          >
            <span>{rightFilter}</span>
            <span>{leftFilter}</span>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              justifyItems: 'center',
              height: '80px',
            }}
            className={styles.title}
          >
            <h3 style={{ textAlign: 'right' }}>{generalSettings.companyName}</h3>
            <h3 style={{ textAlign: 'right' }}>{generalSettings.companyAddress}</h3>
          </div>
          <hr />
          <h3 className={styles.title} style={{ textAlign: 'center' }}>
            {this.state.pageInfo.title}
          </h3>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 15,
            }}
          >
            <span>{rightFilter}</span>
            <span>{leftFilter}</span>
          </div>
        </React.Fragment>
      );
    }
  };
  getTransType = () => {
    let values = [
     // { id: -1, name: $.strings.all },
      { id: 1, name: $.strings.PermissionsLogHistory.transTypeOption1, name_lang2: $.strings.PermissionsLogHistory.transTypeOption1 },
      { id: 2, name: $.strings.PermissionsLogHistory.transTypeOption2, name_lang2: $.strings.PermissionsLogHistory.transTypeOption2 },
      { id: 3, name: $.strings.PermissionsLogHistory.transTypeOption3, name_lang2: $.strings.PermissionsLogHistory.transTypeOption3 },
      { id: 4, name: $.strings.PermissionsLogHistory.transTypeOption4, name_lang2: $.strings.PermissionsLogHistory.transTypeOption4 },
      { id: 5, name: $.strings.PermissionsLogHistory.transTypeOption5, name_lang2: $.strings.PermissionsLogHistory.transTypeOption5 },
      { id: 6, name: $.strings.PermissionsLogHistory.transTypeOption6, name_lang2: $.strings.PermissionsLogHistory.transTypeOption6 },
     // { id: 7, name: $.strings.PermissionsLogHistory.transTypeOption7, name_lang2: $.strings.PermissionsLogHistory.transTypeOption7 },
     // { id: 8, name: $.strings.PermissionsLogHistory.transTypeOption8, name_lang2: $.strings.PermissionsLogHistory.transTypeOption8 },
    ];
    return values;
  };
}
